module.exports = __webpack_public_path__ + "9cf753cfa2bad5c7c1dbc17f9010d536.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/assets/images/plant_transparent.png
// module id = 425
// module chunks = 0